enum QuestionTypes {
	"select" = 1,
	"radio" = 2,
	"datalist" = 3,
	"checkbox" = 4,
	"text" = 5,
	"number" = 6,
	"title" = 7,
	"email" = 8,
	"slider radio" = 9,
	"date" = 10,
	"slider likert" = 11,
	"liker" = 12,
	"percentage" = 13,
	"money" = 14,
	"did you know" = 15,
}

export default QuestionTypes;
